export const BACKGROUND_REMOVAL_PROGRESS_TYPE = {
    DETERMINATE: 'determinate',
    INDETERMINATE: 'indeterminate',
} as const;

export const INDETERMINATE_BACKGROUND_REMOVAL_PROGRESS = {
    type: BACKGROUND_REMOVAL_PROGRESS_TYPE.INDETERMINATE,
} as const;

export type BackgroundRemovalProgress =
    | {
          type: typeof BACKGROUND_REMOVAL_PROGRESS_TYPE.DETERMINATE;
          percentageComplete: number;
      }
    | {
          type: typeof BACKGROUND_REMOVAL_PROGRESS_TYPE.INDETERMINATE;
      };

export type BackgroundRemovalProgressHandler = (progress: BackgroundRemovalProgress) => void;
